import { useCallback, useContext, useRef } from "react";

import { v4 as uuidv4 } from "uuid";

import IMapSidebarContext from "@app/scene/map/types/IMapSidebarContext";

import MapSidebarContext from "./MapSidebarContext";

const useMapSidebar = (prefix: string = ""): ((width: number) => void) => {
  const { setSidebarWidth } = useContext(MapSidebarContext) as unknown as IMapSidebarContext;
  const sidebarId = useRef(`${prefix}${uuidv4()}`); // set once and never changes
  return useCallback(
    (width: number) => {
      setSidebarWidth(width, sidebarId.current);
    },
    [setSidebarWidth]
  );
};

export default useMapSidebar;
